import React, { useEffect, useRef, useState } from "react";
import "./Css/AnalyticsNew.css";
import {
  Bike,
  ChevronDown,
  HandPlatter,
  Package,
  TrendingUp,
  TrendingDown,
  DollarSign,
  ShoppingCart,
  Users,
  Clock,
  Award,
  AlertCircle,
  Download,
  Filter,
  Calendar as CalendarIcon,
  ArrowUpRight,
  ArrowDownRight,
  MoreVertical,
  RefreshCw,
  Activity,
  CheckCircle,
  XCircle,
  Radio,
} from "lucide-react";

// import Select from "react-select";
import {
  server_post_data,
  get_restro_analytics,
  get_restaurant_list,
} from "../ServiceConnection/serviceconnection.js";
import Header from "./Header.js";
import { handleError } from "../CommonJquery/CommonJquery.js";

let default_restaurant_id = "0";
let default_database_name = "Default";

// ---- react-select custom styling ----------------------------------------
// Default react-select renders an unstyled plain list (as seen in the
// screenshot) with no card, no hover state, and can overflow/clip inside
// parent containers that have overflow rules. menuPortalTarget + these
// styles fix both the look and the positioning/clipping issue.

// ---------------------------------------------------------------------------

const AnalyticsNew = () => {
  const [dashData, setDashData] = useState("");
  const [liveOrders, setLiveOrders] = useState([]);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [dailyTrends, setDailyTrends] = useState([]);
  const [hourlyTrends, setHourlyTrends] = useState([]);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [selectedDate, setSelectedDate] = useState("All");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [restuarnt, setrestuarnt] = useState([]);
  const [RestaurantName, setRestaurantName] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const dateDropdownRef = useRef(null);
  const [showRestaurantDropdown, setShowRestaurantDropdown] = useState(false);
  const [restaurantSearch, setRestaurantSearch] = useState("");
  const restaurantDropdownRef = useRef(null);

  const dateOptions = [
    "All",
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Month",
    "Last Month",
  ];

  // Calculate metrics
  const calculateMetrics = () => {
    const totalSales = dashData?.total_sales || 0;
    const totalOrders = dashData?.total_orders || 0;
    const avgOrderValue = totalOrders > 0 ? totalSales / totalOrders : 0;
    const totalTax = dashData?.tax_data?.[0]?.total_tax || 0;
    const totalDiscount = dashData?.discount_list?.[0]?.total_discount || 0;
    const netRevenue = totalSales - totalDiscount;

    return {
      totalSales,
      totalOrders,
      avgOrderValue,
      totalTax,
      totalDiscount,
      netRevenue,
    };
  };

  const metrics = calculateMetrics();

  // Enhanced sales cards with more details
  const enhancedSalesCards = [
    {
      title: "Total Revenue",
      amount: metrics.totalSales,
      orders: dashData?.total_orders || 0,
      icon: <DollarSign size={24} />,
      bgColor: "#4CAF50",
      trend: "+12.5%",
      trendUp: true,
      subtitle: "Net Sales",
    },
    {
      title: "Dine In",
      amount: dashData?.dine_data || 0,
      orders: dashData?.dine_data_orders || 0,
      icon: <HandPlatter size={24} />,
      bgColor: "#FF9800",
      trend: "+8.2%",
      trendUp: true,
      subtitle: "Table Orders",
    },
    {
      title: "Take Away",
      amount: dashData?.takeaway_data || 0,
      orders: dashData?.takeaway_data_count || 0,
      icon: <Package size={24} />,
      bgColor: "#2196F3",
      trend: "-3.1%",
      trendUp: false,
      subtitle: "Pickup Orders",
    },
    {
      title: "Delivery",
      amount: dashData?.delivery_data || 0,
      orders: dashData?.delivery_data_count || 0,
      icon: <Bike size={24} />,
      bgColor: "#9C27B0",
      trend: "+15.7%",
      trendUp: true,
      subtitle: "Online Orders",
    },
  ];

  // KPI Cards
  const kpiCards = [
    {
      title: "Avg Order Value",
      value: `₹${metrics.avgOrderValue.toFixed(2)}`,
      icon: <ShoppingCart size={20} />,
      color: "#4CAF50",
    },
    {
      title: "Success Rate",
      value: `${dashData?.success_count || 0}/${dashData?.total_orders || 0}`,
      icon: <Award size={20} />,
      color: "#2196F3",
    },
    {
      title: "Cancel Rate",
      value: `${(
        (dashData?.cancel_count / (dashData?.total_orders || 1)) *
        100
      ).toFixed(1)}%`,
      icon: <AlertCircle size={20} />,
      color: "#f44336",
    },
    {
      title: "Net Revenue",
      value: `₹${metrics.netRevenue.toFixed(2)}`,
      icon: <TrendingUp size={20} />,
      color: "#FF9800",
    },
  ];

  // Payment breakdown
  const paymentBreakdown = [
    {
      method: "Cash",
      amount: dashData?.cash_data || 0,
      percentage: (
        ((dashData?.cash_data || 0) / metrics.totalSales) *
        100
      ).toFixed(1),
      color: "#4CAF50",
    },
    {
      method: "Card",
      amount: dashData?.card_data || 0,
      percentage: (
        ((dashData?.card_data || 0) / metrics.totalSales) *
        100
      ).toFixed(1),
      color: "#2196F3",
    },
    {
      method: "Online (UPI)",
      amount: dashData?.online_data || 0,
      percentage: (
        ((dashData?.online_data || 0) / metrics.totalSales) *
        100
      ).toFixed(1),
      color: "#9C27B0",
    },
    {
      method: "Other",
      amount: dashData?.other_data || 0,
      percentage: (
        ((dashData?.other_data || 0) / metrics.totalSales) *
        100
      ).toFixed(1),
      color: "#FF9800",
    },
  ];

  // Top products data
  const topProducts = dashData?.top_sold_items_list || [];

  const toggleDateDropdown = (e) => {
    setShowDateDropdown(!showDateDropdown);
    e.stopPropagation();
  };

  const handleDateSelect = (dateOption) => {
    const today = new Date();
    let startDate, endDate;

    switch (dateOption) {
      case "All":
        setStartDate("");
        setEndDate("");
        setSelectedDate(dateOption);
        setShowDateDropdown(false);
        // Call API with empty dates for "All"
        master_data_get_dash("", "");
        return;
      case "Today":
        startDate = endDate = today;
        break;
      case "Yesterday":
        startDate = endDate = new Date(today);
        startDate.setDate(today.getDate() - 1);
        break;
      case "Last 7 Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        endDate = today;
        break;
      case "Last 30 Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 29);
        endDate = today;
        break;
      case "This Month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = today;
        break;
      case "Last Month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        return;
    }

    const formatDate = (date) => date.toISOString().split("T")[0];
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
    setSelectedDate(dateOption);
    setShowDateDropdown(false);

    // Call API with formatted dates
    master_data_get_dash(formattedStartDate, formattedEndDate);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setShowDateDropdown(false);
      }
      if (
        restaurantDropdownRef.current &&
        !restaurantDropdownRef.current.contains(event.target)
      ) {
        setShowRestaurantDropdown(false);
        setRestaurantSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Initial load - only called once
    master_data_get(1);
  }, []);

  const master_data_get = async (flag) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", flag);
    await server_post_data(get_restaurant_list, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setrestuarnt(Response.data.message.reservation_list);
          default_restaurant_id =
            Response.data.message.reservation_list[0].primary_id;
          setRestaurantName(
            Response.data.message.reservation_list[0].restaurant_name +
              " (" +
              Response.data.message.reservation_list[0].restaurant_city +
              ")",
          );
          default_database_name =
            Response.data.message.reservation_list[0].database_name;
          master_data_get_dash(start_date, end_date);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const master_data_get_dash = async (startdate, enddate) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("restaurant_id", default_restaurant_id);
    fd.append("start_date", startdate);
    fd.append("end_date", enddate);

    await server_post_data(get_restro_analytics, fd, default_database_name)
      .then((Response) => {
        if (!Response.data.error) {
          setDashData(Response.data.message);

          // Process daily trends
          if (Response.data.message.daily_trends) {
            setDailyTrends(Response.data.message.daily_trends);
          }

          // Process hourly trends
          if (Response.data.message.hourly_trends) {
            setHourlyTrends(Response.data.message.hourly_trends);
          }

          // Process live orders
          if (Response.data.message.recent_orders) {
            setLiveOrders(Response.data.message.recent_orders);
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  const handleRestaurantSelect = (option) => {
    default_restaurant_id = option.primary_id;
    default_database_name = option.database_name;
    setRestaurantName(
      option.restaurant_name + " (" + option.restaurant_city + ")",
    );
    setShowRestaurantDropdown(false);
    setRestaurantSearch("");
    master_data_get_dash(start_date, end_date);
  };

  const handleRefresh = () => {
    master_data_get_dash(start_date, end_date);
  };
  const filteredRestaurants =
    restuarnt && restuarnt.length > 0
      ? restuarnt.filter((r) =>
          (r.restaurant_name + " " + r.restaurant_city)
            .toLowerCase()
            .includes(restaurantSearch.toLowerCase()),
        )
      : [];

  const toggleOrderDetails = (orderId) => {
    setExpandedOrder(expandedOrder === orderId ? null : orderId);
  };

  return (
    <>
      <Header />
      <div className="analytics-upgraded-container">
        {/* Header Section */}
        <div className="analytics-header">
          <div className="header-top">
            <div className="header-left">
              <h1 className="page-title">Analytics Dashboard</h1>
              <p className="page-subtitle">
                Monitor your restaurant performance
              </p>
            </div>
            <div className="header-actions">
              <button className="btn-icon" onClick={handleRefresh}>
                <RefreshCw size={18} />
              </button>
              <button className="btn-icon">
                <Download size={18} />
                <span>Export</span>
              </button>
            </div>
          </div>

          {/* Filters */}
          <div className="filters-row">
            <div className="filter-group">
              <div className="filter-group" ref={restaurantDropdownRef}>
                <button
                  className="restaurant-filter-btn"
                  onClick={() =>
                    setShowRestaurantDropdown(!showRestaurantDropdown)
                  }
                >
                  <span className="restaurant-filter-label">
                    {RestaurantName || "Select Restaurant"}
                  </span>
                  <ChevronDown size={16} />
                </button>

                {showRestaurantDropdown && (
                  <div className="restaurant-dropdown-menu">
                    <input
                      type="text"
                      className="restaurant-search-input"
                      placeholder="Search restaurant..."
                      value={restaurantSearch}
                      onChange={(e) => setRestaurantSearch(e.target.value)}
                      autoFocus
                    />
                    <div className="restaurant-options-list">
                      {filteredRestaurants.length > 0 ? (
                        filteredRestaurants.map((option) => (
                          <div
                            key={option.primary_id}
                            className={`restaurant-option ${
                              default_restaurant_id === option.primary_id
                                ? "active"
                                : ""
                            }`}
                            onClick={() => handleRestaurantSelect(option)}
                          >
                            {option.restaurant_name} ({option.restaurant_city})
                          </div>
                        ))
                      ) : (
                        <div className="restaurant-no-options">
                          No restaurants found
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="filter-group" ref={dateDropdownRef}>
              <button className="date-filter-btn" onClick={toggleDateDropdown}>
                <CalendarIcon size={16} />
                <span>{selectedDate}</span>
                <ChevronDown size={16} />
              </button>

              {showDateDropdown && (
                <div className="date-dropdown-menu">
                  {dateOptions.map((option, index) => (
                    <div
                      key={index}
                      className={`date-option ${
                        selectedDate === option ? "active" : ""
                      }`}
                      onClick={() => handleDateSelect(option)}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="analytics-content">
          {/* KPI Cards Row */}
          <div className="kpi-cards-row">
            {kpiCards.map((kpi, index) => (
              <div key={index} className="kpi-card">
                <div
                  className="kpi-icon"
                  style={{
                    backgroundColor: kpi.color + "20",
                    color: kpi.color,
                  }}
                >
                  {kpi.icon}
                </div>
                <div className="kpi-content">
                  <p className="kpi-title">{kpi.title}</p>
                  <h3 className="kpi-value">{kpi.value}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* Enhanced Sales Cards */}
          <div className="sales-cards-grid">
            {enhancedSalesCards.map((card, index) => (
              <div key={index} className="enhanced-sales-card">
                <div className="card-header">
                  <div
                    className="card-icon"
                    style={{
                      backgroundColor: card.bgColor + "20",
                      color: card.bgColor,
                    }}
                  >
                    {card.icon}
                  </div>
                  <button className="btn-more">
                    <MoreVertical size={16} />
                  </button>
                </div>
                <div className="card-body">
                  <p className="card-title">{card.title}</p>
                  <h2 className="card-amount">
                    ₹{parseFloat(card.amount).toFixed(2)}
                  </h2>
                  <div className="card-footer">
                    <div className="orders-info">
                      <ShoppingCart size={14} />
                      <span>{card.orders} Orders</span>
                    </div>
                    <div
                      className={`trend ${
                        card.trendUp ? "trend-up" : "trend-down"
                      }`}
                    >
                      {card.trendUp ? (
                        <ArrowUpRight size={14} />
                      ) : (
                        <ArrowDownRight size={14} />
                      )}
                      <span>{card.trend}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Charts and Details Section */}
          <div className="charts-section">
            {/* Best Sellers Chart */}
            <div className="chart-card best-sellers-card">
              <div className="chart-header">
                <h3>Best Selling Items</h3>
                <button className="btn-text">View All</button>
              </div>
              <div className="chart-content">
                <div className="bar-chart-container">
                  {topProducts.length > 0 ? (
                    topProducts.slice(0, 5).map((item, index) => {
                      const maxSales = Math.max(
                        ...topProducts.map((i) => i.total_sold),
                      );
                      const percentage = (item.total_sold / maxSales) * 100;

                      return (
                        <div key={index} className="bar-item">
                          <div className="bar-info">
                            <span className="bar-rank">#{index + 1}</span>
                            <span className="bar-label">{item.item_name}</span>
                          </div>
                          <div className="bar-visual">
                            <div className="bar-track">
                              <div
                                className="bar-fill"
                                style={{ width: `${percentage}%` }}
                              ></div>
                            </div>
                            <span className="bar-value">{item.total_sold}</span>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-data">
                      <p>No sales data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Payment Methods */}
            <div className="chart-card payment-card">
              <div className="chart-header">
                <h3>Payment Methods</h3>
                <span className="total-amount">
                  ₹{metrics.totalSales.toFixed(2)}
                </span>
              </div>
              <div className="chart-content">
                <div className="payment-breakdown">
                  {paymentBreakdown.map((payment, index) => (
                    <div key={index} className="payment-item">
                      <div className="payment-header">
                        <div className="payment-label">
                          <div
                            className="payment-dot"
                            style={{ backgroundColor: payment.color }}
                          ></div>
                          <span>{payment.method}</span>
                        </div>
                        <span className="payment-percentage">
                          {payment.percentage}%
                        </span>
                      </div>
                      <div className="payment-bar">
                        <div
                          className="payment-fill"
                          style={{
                            width: `${payment.percentage}%`,
                            backgroundColor: payment.color,
                          }}
                        ></div>
                      </div>
                      <div className="payment-amount">
                        ₹{payment.amount.toFixed(2)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Daily Trends Section */}
          <div className="trends-section">
            <div className="chart-card trends-card">
              <div className="chart-header">
                <div className="header-with-icon">
                  <Activity size={20} color="#3b82f6" />
                  <h3>Daily Order Trends</h3>
                </div>
                <div className="trend-summary">
                  <span className="trend-label">Today vs Yesterday</span>
                  {dailyTrends.length >= 2 && (
                    <span
                      className={`trend-value ${
                        dailyTrends[0]?.order_count >
                        dailyTrends[1]?.order_count
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {dailyTrends[0]?.order_count >
                      dailyTrends[1]?.order_count ? (
                        <ArrowUpRight size={14} />
                      ) : (
                        <ArrowDownRight size={14} />
                      )}
                      {dailyTrends[0]?.order_count || 0} orders today
                    </span>
                  )}
                </div>
              </div>
              <div className="chart-content">
                <div className="daily-trends-chart">
                  {dailyTrends && dailyTrends.length > 0 ? (
                    dailyTrends
                      .slice(0, 7)
                      .reverse()
                      .map((day, index) => {
                        const maxOrders = Math.max(
                          ...dailyTrends.slice(0, 7).map((d) => d.order_count),
                        );
                        const height =
                          maxOrders > 0
                            ? (day.order_count / maxOrders) * 100
                            : 0;
                        const isToday =
                          index === dailyTrends.slice(0, 7).length - 1;

                        return (
                          <div key={index} className="daily-bar-item">
                            <div className="bar-value-top">
                              {day.order_count}
                            </div>
                            <div className="bar-container">
                              <div
                                className={`daily-bar ${
                                  isToday ? "today" : ""
                                }`}
                                style={{ height: `${height}%` }}
                              >
                                <div className="bar-tooltip">
                                  <div className="tooltip-orders">
                                    {day.order_count} orders
                                  </div>
                                  <div className="tooltip-revenue">
                                    ₹{parseFloat(day.total_sales).toFixed(2)}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="bar-label">
                              <div className="day-name">
                                {new Date(day.date).toLocaleDateString(
                                  "en-IN",
                                  { weekday: "short" },
                                )}
                              </div>
                              <div className="day-date">
                                {new Date(day.date).toLocaleDateString(
                                  "en-IN",
                                  { month: "short", day: "numeric" },
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <div className="no-data">
                      <Activity size={40} color="#d1d5db" />
                      <p>
                        No daily trends data available. Select a date range.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Hourly Trends */}
            <div className="chart-card hourly-card">
              <div className="chart-header">
                <div className="header-with-icon">
                  <Clock size={20} color="#10b981" />
                  <h3>Peak Hours Analysis</h3>
                </div>
              </div>
              <div className="chart-content">
                <div className="hourly-trends-chart">
                  {hourlyTrends && hourlyTrends.length > 0 ? (
                    hourlyTrends.map((hour, index) => {
                      const maxOrders = Math.max(
                        ...hourlyTrends.map((h) => h.order_count),
                      );
                      const width =
                        maxOrders > 0
                          ? (hour.order_count / maxOrders) * 100
                          : 0;

                      return (
                        <div key={index} className="hourly-bar-item">
                          <div className="hour-label">{hour.hour}</div>
                          <div className="hourly-bar-container">
                            <div
                              className="hourly-bar-fill"
                              style={{ width: `${width}%` }}
                            ></div>
                            <span className="hourly-value">
                              {hour.order_count}
                            </span>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-data">
                      <Clock size={40} color="#d1d5db" />
                      <p>No hourly data available. Orders will appear here.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Live Orders Section */}
          <div className="live-orders-section">
            <div className="chart-card live-orders-card">
              <div className="chart-header">
                <div className="header-with-icon">
                  <Radio size={20} color="#ef4444" className="pulse-icon" />
                  <h3>Recent Orders</h3>
                  <span className="live-badge">LIVE</span>
                </div>
                <button className="btn-text" onClick={handleRefresh}>
                  <RefreshCw size={14} />
                  Refresh
                </button>
              </div>
              <div className="chart-content">
                <div className="orders-list">
                  {liveOrders && liveOrders.length > 0 ? (
                    liveOrders.slice(0, 10).map((order, index) => {
                      const orderTime = new Date(order.entry_date);
                      const now = new Date();
                      const diffMinutes = Math.floor(
                        (now - orderTime) / (1000 * 60),
                      );
                      const timeAgo =
                        diffMinutes < 1
                          ? "Just now"
                          : diffMinutes < 60
                            ? `${diffMinutes}m ago`
                            : `${Math.floor(diffMinutes / 60)}h ago`;

                      const statusConfig = {
                        0: {
                          label: "New",
                          color: "#3b82f6",
                          icon: <ShoppingCart size={14} />,
                        },
                        1: {
                          label: "Preparing",
                          color: "#f59e0b",
                          icon: <Clock size={14} />,
                        },
                        2: {
                          label: "Completed",
                          color: "#10b981",
                          icon: <CheckCircle size={14} />,
                        },
                        3: {
                          label: "Hold",
                          color: "#6b7280",
                          icon: <Clock size={14} />,
                        },
                        10: {
                          label: "Cancelled",
                          color: "#ef4444",
                          icon: <XCircle size={14} />,
                        },
                      };

                      const status =
                        statusConfig[order.current_status] || statusConfig[0];
                      const orderTypeLabels = {
                        1: "Takeaway",
                        2: "Delivery",
                        3: "Dine-in",
                      };
                      const isExpanded = expandedOrder === order.primary_id;

                      return (
                        <div key={index} className="order-item-wrapper">
                          <div
                            className="order-item"
                            onClick={() => toggleOrderDetails(order.primary_id)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="order-left">
                              <div className="order-id-row">
                                <div className="order-id">
                                  #{order.primary_id}
                                </div>
                                <ChevronDown
                                  size={16}
                                  className={`expand-icon ${
                                    isExpanded ? "expanded" : ""
                                  }`}
                                  style={{
                                    color: "#6b7280",
                                    transition: "transform 0.3s",
                                  }}
                                />
                              </div>
                              <div className="order-details">
                                <span className="order-type">
                                  {orderTypeLabels[order.order_type] || "Other"}
                                </span>
                                {order.table_code_names && (
                                  <span className="order-table">
                                    • {order.table_code_names}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="order-center">
                              <div className="order-amount">
                                ₹{parseFloat(order.final_amount).toFixed(2)}
                              </div>
                              <div className="order-time">{timeAgo}</div>
                            </div>
                            <div className="order-right">
                              <div
                                className="order-status"
                                style={{
                                  backgroundColor: status.color + "20",
                                  color: status.color,
                                }}
                              >
                                {status.icon}
                                <span>{status.label}</span>
                              </div>
                            </div>
                          </div>

                          {/* Order Details Expansion */}
                          {isExpanded &&
                            order.items &&
                            order.items.length > 0 && (
                              <div className="order-details-expanded">
                                <div className="order-items-header">
                                  <h4>Order Items</h4>
                                  <span className="items-count">
                                    {order.items.length} items
                                  </span>
                                </div>
                                <div className="order-items-list">
                                  {order.items.map((item, idx) => (
                                    <div
                                      key={idx}
                                      className="order-item-detail"
                                    >
                                      <div className="item-info">
                                        <div className="item-name">
                                          {item.item_name}
                                        </div>
                                        {item.item_notes && (
                                          <div className="item-notes">
                                            Note: {item.item_notes}
                                          </div>
                                        )}
                                        {item.variation_name && (
                                          <div className="item-variation">
                                            Variant: {item.variation_name}
                                          </div>
                                        )}
                                      </div>
                                      <div className="item-quantity">
                                        Qty: {item.item_qty}
                                      </div>
                                      <div className="item-amount">
                                        ₹
                                        {parseFloat(item.total_amount).toFixed(
                                          2,
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className="order-summary">
                                  <div className="summary-row">
                                    <span>Subtotal</span>
                                    <span>
                                      ₹
                                      {parseFloat(
                                        order.product_amount || 0,
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                  {order.tax_amount > 0 && (
                                    <div className="summary-row">
                                      <span>Tax</span>
                                      <span>
                                        ₹
                                        {parseFloat(order.tax_amount).toFixed(
                                          2,
                                        )}
                                      </span>
                                    </div>
                                  )}
                                  {order.discount_amount > 0 && (
                                    <div className="summary-row discount">
                                      <span>Discount</span>
                                      <span>
                                        -₹
                                        {parseFloat(
                                          order.discount_amount,
                                        ).toFixed(2)}
                                      </span>
                                    </div>
                                  )}
                                  <div className="summary-row total">
                                    <span>Total</span>
                                    <span>
                                      ₹
                                      {parseFloat(order.final_amount).toFixed(
                                        2,
                                      )}
                                    </span>
                                  </div>
                                </div>
                                {order.payment_mode && (
                                  <div className="order-payment-info">
                                    <span className="payment-mode-label">
                                      Payment:
                                    </span>
                                    <span className="payment-mode-value">
                                      {order.payment_mode}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-data">
                      <ShoppingCart size={40} color="#d1d5db" />
                      <p>
                        No recent orders. Orders will appear here in real-time.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Stats */}
          <div className="bottom-stats">
            {/* Order Statistics */}
            <div className="stat-card">
              <div className="stat-header">
                <h3>Order Statistics</h3>
              </div>
              <div className="stat-grid">
                <div className="stat-item">
                  <div className="stat-icon success">
                    <Award size={20} />
                  </div>
                  <div className="stat-details">
                    <p className="stat-label">Completed</p>
                    <h4 className="stat-value">
                      {dashData?.success_count || 0}
                    </h4>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon danger">
                    <AlertCircle size={20} />
                  </div>
                  <div className="stat-details">
                    <p className="stat-label">Cancelled</p>
                    <h4 className="stat-value">
                      {dashData?.cancel_count || 0}
                    </h4>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon warning">
                    <Clock size={20} />
                  </div>
                  <div className="stat-details">
                    <p className="stat-label">Avg Time</p>
                    <h4 className="stat-value">25 min</h4>
                  </div>
                </div>
              </div>
            </div>

            {/* Tax Breakdown */}
            <div className="stat-card">
              <div className="stat-header">
                <h3>Tax Summary</h3>
              </div>
              <div className="tax-breakdown">
                <div className="tax-row">
                  <span className="tax-label">CGST</span>
                  <span className="tax-value">
                    ₹{(dashData?.tax_data?.[0]?.total_cgst || 0).toFixed(2)}
                  </span>
                </div>
                <div className="tax-row">
                  <span className="tax-label">SGST</span>
                  <span className="tax-value">
                    ₹{(dashData?.tax_data?.[0]?.total_sgst || 0).toFixed(2)}
                  </span>
                </div>
                <div className="tax-row total">
                  <span className="tax-label">Total Tax</span>
                  <span className="tax-value">
                    ₹{(dashData?.tax_data?.[0]?.total_tax || 0).toFixed(2)}
                  </span>
                </div>
                <div className="tax-row discount">
                  <span className="tax-label">Total Discount</span>
                  <span className="tax-value text-danger">
                    -₹
                    {(
                      dashData?.discount_list?.[0]?.total_discount || 0
                    ).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            {/* Financial Summary */}
            <div className="stat-card">
              <div className="stat-header">
                <h3>Financial Summary</h3>
              </div>
              <div className="financial-summary">
                <div className="financial-row">
                  <span>Gross Sales</span>
                  <span className="amount">
                    ₹{metrics.totalSales.toFixed(2)}
                  </span>
                </div>
                <div className="financial-row">
                  <span>Discount</span>
                  <span className="amount text-danger">
                    -₹{metrics.totalDiscount.toFixed(2)}
                  </span>
                </div>
                <div className="financial-row">
                  <span>Tax</span>
                  <span className="amount">₹{metrics.totalTax.toFixed(2)}</span>
                </div>
                <div className="financial-row total">
                  <span>Net Revenue</span>
                  <span className="amount">
                    ₹{metrics.netRevenue.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Loader */}
        {showLoaderAdmin && (
          <div className="loader-overlay">
            <div className="loader-spinner"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default AnalyticsNew;
